'use strict';

angular.module('schoolbushubApp')
    .service('DateUtils', function ($filter) {

    this.convertLocaleDateToServer = function(date) {
        if (date) {
            return $filter('date')(date, 'yyyy-MM-dd');
        } else {
            return null;
        }
    };

    this.convertLocaleDateFromServer = function(date) {
        if (date) {
            var dateString = date.split("-");
            return new Date(dateString[0], dateString[1] - 1, dateString[2]);
        }
        return null;
    };

    this.convertDateTimeFromServer = function(date) {
        if (date) {
            return new Date(date);
        } else {
            return null;
        }
    };

    // common date format for all date input fields
    this.dateformat = function() {
        return 'yyyy-MM-dd';
    };

    this.dateTimeFormat = function (d) {
        if (!d) return '--';
        return moment.utc(d).format('MM/DD/YYYY h:mm A');
    };

    this.timeFormat = function(d) {
        if (!d) return '--';
        return moment.utc(d).format('h:mm A');
    };

    this.timeFormatWithTz = function(d, tz) {
        if (!d || !tz) return '--';
        return moment.utc(d).tz(tz).format('h:mm A');
    }
});
